module.exports = __webpack_public_path__ + "img/step3_1.4eae9533.jpg";